import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from '@mui/material/Box'
import './Project.css';
import hope from '../../Assets/Projects/hope.png';
import homepage from '../../Assets/Projects/homepage.png';
import form from '../../Assets/Projects/form.png';
import myopiatest from '../../Assets/Projects/myopiatest.png';
import myopiaresult from '../../Assets/Projects/myopiaresult.png';
import cbresult from '../../Assets/Projects/cbresult.jpg';
import cbtest from '../../Assets/Projects/cbtest.jpg';
import period from '../../Assets/period.svg';
import {Link} from 'react-router-dom';
import NavBar from "../Navbar";
import YoutubeEmbed from "../YoutubeEmbed";
import Footer from "../Footer";

function Hope() {
  return (
    <section>
      <NavBar />
      <Box className="filebox">

            <Row>
            <aside>
              <Col sm={1}>
                <Container style={{ height: '100%' }}>
            <div direction="right" className="side-banner">
            <div className="marquee">
              <div className="marquee-content" style={{animationDuration: '100s' }}>
                Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor         Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor         Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor         Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor         Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor         Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          Health Predictor          
                </div>
                </div>
                </div>
                </Container>
              </Col>
              <Col sm={10} className="canteen-ui" style={{ paddingLeft: '130px', paddingRight: '70px' }}>
              <Container fluid className="project-section">
          <Container  className="canteen-content">
                <Row className="first-img" style={{ justifyContent: "center", paddingTop: '40px', paddingBottom: "40px" }}>

                <img
                      src={hope}
                      alt="health predictor"
                      className="img-fluid"
                      style={{marginBottom: '30px', padding: '0px', border: '1px solid white'}}
                    />
                  </Row>
                  <Row style={{paddingBottom: "40px"}}>
                  <div style={{display:'flex'}}>
                  <h1>HoPE (Health Predictor)
                  <img
                    src={period}
                    alt="period"
                    className="img-fluid"
                    style={{marginLeft: '2px', paddingTop: '3%', }}
                  />
                  </h1>
                  
                  </div>
                  <p className="content">Keeping the drastic lifestyle changes in mind, we chose to create a system that aids in predicting and diagnosing 4 ailments- Myopia, Colour Blindness,
Polycystic Ovarian Disease (PCOD), and Probability of Heart Attack. Subsequently if the ailments are detected, we recommend them with specialists near them. Also, the results of the diagnosis would be stored in the user's health journal. </p>
<p className="content">Code available on Github: <a style={{color: '#F9D63D'}} href="https://github.com/devanshijhaveri24/HoPE-Health-Predictor" rel="noopener noreferrer" target="_blank">Website Link</a> <a style={{color: '#F9D63D'}} href="https://github.com/devanshijhaveri24/HealthPredictor" rel="noopener noreferrer" target="_blank">App Link</a></p>
                  
                </Row>
                <Row style={{paddingBottom: "56px", fontFamily: 'Changa'}} >
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">MY ROLE</p>
                    <p className="box-p">UI/UX Designer, Frontend Developer</p>
                    </div>
                    </Col>
                    
                    
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TIMELINE</p>
                    <p className="box-p">4 Semesters (Sem III - Sem VI)</p>
                    </div>
                    </Col>
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TOOLS USED</p>
                    <p className="box-p">Figma, HTML/CSS, Django, Firebase, Flutter</p>
                    </div>
                    </Col>
                    {/* <Col className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="content">PUBLICATIONS</p>
                    <p className="content">Figma, HTML/CSS, Django, Firebase, Flutter</p>
                    </div>
                    </Col> */}
                </Row>
                <Row style={{paddingBottom: "32px"}}>
                    <Col>
                    <hr></hr>
                    <Row>
                    <div style={{display:'flex'}}>
                      <h2> THE BRIEF</h2> 
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    </Row>
                    <h5>OVERVIEW</h5>
                    <p className="content">As part of the Innovative Project Development (IPD) course, we were required to identify a social issue and develop a project on it. Before implementing our project, we were required to conduct extensive user research, examine relevant literature, and analyse existing systems over the course of three semesters. </p>
                    </Col>
                </Row>
                {/* <Row style={{paddingBottom: "40px", }}>
                <img
                      src={process}
                      alt="process"
                      className="img-fluid"
                      style={{ maxHeight: "300px" }}
                    />
                    </Row> */}
                
                    <Row style={{paddingBottom: "32px"}}>
                    <Col>
                    <hr></hr>
                    <div  style={{display: 'flex'}}>
                      <h2 style={{display: 'flex'}}> MY CONTRIBUTION</h2> 
                      <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{ justifyItems: 'start', margin: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">01</p>
                      </Col>
                      <Col>
                      <p className="content">Conducted market research and reviewed relevant literature to gain a deep understanding of the diagnosis of Myopia and Color Blindness</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">02</p>
                      </Col>
                      <Col>
                      <p className="content">Generated the process flow for Myopia diagnosis, ensuring that the process was clear and simple for users to understand.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">03</p>
                      </Col>
                      <Col>
                      <p className="content">Designed the entire user interface for the website and mobile app using HTML and Flutter. This involved collaborating closely with the project team to ensure that the final product was visually appealing and user-friendly.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">04</p>
                      </Col>
                      <Col>
                      <p className="content">Documented my work through reports, presentations, and a research paper.</p>
                      </Col>
                    </Row>
                    </Col>
                </Row>
                
                <Row style={{paddingBottom:"32px"}}>
                  <Col>
                    
                    <hr></hr>
                    <div style={{display: 'flex'}}>
                    <h2>HIGH FIDELITY DESIGNS
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '3%', verticalAlign: 'bottom' }}
                    /></h2>
                    </div>
                    <h4>WEBSITE VERSION:</h4>
                    <p className="content">It consists of Landing Page, Log In/Sign Up, PCOD, Heart Attack Probability and Doctor Recommendation modules.</p>
                    <YoutubeEmbed embedId="_IsC8STzxVU" />
                    <h4 style={{paddingTop: "40px"}}>MOBILE VERSION:</h4>
                    <p className="content">It consists of User Detail Form, Myopia and Colour Blindness modules.</p>
                    <Row>
                      <Col>
                      <img
                      src={form}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingBottom: '16px'}}
                      />
                      </Col>
                      <Col>
                      <img
                      src={homepage}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingBottom: '16px'}}
                      />
                      </Col>
                      <Col>
                      <img
                      src={myopiatest}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingBottom: '16px'}}
                      />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                      <img
                      src={myopiaresult}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingBottom: '16px'}}
                      />
                      </Col>
                      <Col>
                      <img
                      src={cbtest}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingBottom: '16px'}}
                      />
                      </Col>
                      <Col>
                      <img
                      src={cbresult}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingBottom: '16px'}}
                      />
                      </Col>
                    </Row>
                  </Col>
                </Row>

{/* 
                <Row style={{paddingBottom:"30px", paddingTop:"40px"}}>
                  <Col>
                    <hr></hr>
                    <div style={{display: 'flex'}}>
                    <h2>TAKEAWAYS</h2>
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="content">01</p>
                      </Col>
                      <Col>
                      <p className="content">Collaborating with a team of five members can pose several challenges, primarily when incorporating diverse viewpoints. Hence, clear communication is vital.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="content">02</p>
                      </Col>
                      <Col>
                      <p className="content">Establishing a realistic timeline and adhering to it is crucial in ensuring that the project remains on track and meets its objectives.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="content">03</p>
                      </Col>
                      <Col>
                      <p className="content">Adopting an Agile framework can streamline the product development process by allowing for continuous feedback and adjustments in subsequent iterations.</p>
                      </Col>
                    </Row>
                  </Col>
                </Row> */}

                <Row style={{marginBottom: "100px", paddingTop:"40px", fontFamily: 'Changa', fontSize: '1.2em'}}>
                  <Link to={'/project/ecanteen'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute'}}>
                    Previous
                    </div>
                  </Link>
                  <Link to={'/project/videochat'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute', right:'0px'}}>
                    Next
                    </div>
                  </Link>
                </Row> 

                </Container>
        </Container>
              </Col>
              </aside>
            </Row>
         
        <Footer />
      </Box>
    </section>
  );
}

export default Hope;
